/* istanbul ignore file */
import * as React from "react";
import type { SVGProps } from "react";
import PropTypes from "prop-types";

interface Props extends SVGProps<SVGSVGElement> {
  srText?: string;
  size?: "sm" | "md" | "lg" | "scale-8" | "scale-10" | number;
  alt?: string;
}
function IconPeopleConversing({
  srText,
  size = "md",
  className = "",
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return (
    <>
      {!!srText && <span className="mc-sr-only">{srText}</span>}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        aria-hidden="true"
        role="img"
        className={newClassName}
        {...props}
      >
        <g
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.625}
        >
          <path
            d="M18.492 3.847c0 .757.299 1.48.83 2.014a2.86 2.86 0 0 0 2.018.834c.751 0 1.476-.3 2.013-.834a2.86 2.86 0 0 0 .834-2.014 2.87 2.87 0 0 0-.834-2.015A2.86 2.86 0 0 0 21.34 1c-.756 0-1.481.3-2.017.833a2.87 2.87 0 0 0-.83 2.015M18.896 22.56A2.445 2.445 0 0 0 21.34 25a2.445 2.445 0 0 0 2.439-2.442v-4.066c.43 0 .844-.174 1.151-.478.303-.305.475-.72.475-1.151v-4.88a3.253 3.253 0 0 0-3.252-3.254h-1.63a3.255 3.255 0 0 0-3.252 3.254v4.88c0 .431.17.846.474 1.15.308.305.72.479 1.151.479ZM3.845 3.847c0 .757.303 1.48.835 2.014a2.86 2.86 0 0 0 2.013.834c.756 0 1.48-.3 2.017-.834a2.85 2.85 0 0 0 .83-2.014c0-.754-.298-1.477-.83-2.015A2.86 2.86 0 0 0 6.693 1c-.752 0-1.477.3-2.013.833a2.87 2.87 0 0 0-.835 2.015M4.254 22.56A2.445 2.445 0 0 0 6.693 25a2.44 2.44 0 0 0 2.443-2.441v-4.067h3.252l-1.626-4.884v-1.625A3.253 3.253 0 0 0 7.51 8.73H5.88a3.255 3.255 0 0 0-3.252 3.254v1.625l-1.626 4.884h3.252ZM11.435 1.545a3.26 3.26 0 0 1 .954 2.302 3.216 3.216 0 0 1-.954 2.302M16.598 1.545a3.26 3.26 0 0 0-.954 2.302 3.216 3.216 0 0 0 .954 2.302"
            transform="scale(.88889 .92308)"
          />
        </g>
      </svg>
    </>
  );
}
IconPeopleConversing.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
} as PropTypes.ValidationMap<Props>;
export default IconPeopleConversing;
